import Icon from "@iconify/react";
import { useSnackbar } from "notistack";
import { useEffect } from "react";
import { MIconButton } from "src/theme";
import closeFill from "@iconify-icons/eva/close-fill";
import { prefetchCartaCamarero } from "src/routes/prefetch";
import { PATH_APP } from "src/routes/paths";

// Avisos de red. La resincronización al despertar la pestaña / recuperar
// la red la hace el orquestador de vuelta (realtime/tpvResume), montado
// con los hubs del TPV: aquí solo quedan los snackbars y la precarga.
export default function useBackgroundSyncDetect() {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  useEffect(() => {
    const closeAction = (key) => (
      <MIconButton size="small" onClick={() => closeSnackbar(key)}>
        <Icon icon={closeFill} />
      </MIconButton>
    );

    const handleOnline = () => {
      enqueueSnackbar("Conexión restablecida. Sincronizando...", {
        variant: "success",
        action: closeAction,
      });
    };

    const handleOffline = () => {
      enqueueSnackbar(
        "Atención: No hay conexión a internet. Los cambios no se guardarán.",
        { variant: "error", action: closeAction },
      );
    };

    window.addEventListener("online", handleOnline);
    window.addEventListener("offline", handleOffline);

    // En el plano de mesas del TPV precargamos la carta camarero en idle.
    if (window.location.pathname.startsWith(PATH_APP.tuCarta.tpv)) {
      prefetchCartaCamarero();
    }

    return () => {
      window.removeEventListener("online", handleOnline);
      window.removeEventListener("offline", handleOffline);
    };
  }, []);

  return [];
}
